import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Avatar from '../../atoms/message/Avatar';
import Flex from '../../atoms/Flex';
const StyledFlex = styled(Flex) `
    align-items: flex-end;
    justify-content: space-between;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6ebee;
`;
const Name = styled.span `
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: ${props => props.theme.primary.base};
`;
const Function = styled.span `
    display: block;
    font-size: 15px;
    font-weight: 400;
    color: ${props => props.theme.primary.base};
    color: ${props => props.variant === 'contractor' ? props.theme.secondary : '#A6A7A7'};
`;
const Date = styled.span `
    font-size: 15px;
    font-weight: 400;
    color: #a6a7a7;
    margin-bottom: 7px;
`;
const Author = ({ name, role, initials, date, variant, }) => {
    return (_jsxs(StyledFlex, { margin: "0 0 15px 0", children: [_jsxs(Flex, { children: [_jsx(Avatar, { variant: variant, initials: initials }), _jsxs(Flex, { column: true, children: [_jsx(Name, { children: name }), _jsx(Function, { variant: variant, children: role })] })] }), _jsx(Date, { children: date })] }));
};
export default Author;
